import { UploadFile, FormInstance } from "antd";

export const validateDeliverables = (
  deliverables: any,
  isDataUploadPage: boolean,
  formValues?: any,
) => {
  if (
    deliverables &&
    Object.values(deliverables).some((item: any) => item.checked)
  ) {
    return Promise.resolve();
  }
  if (
    isDataUploadPage &&
    formValues &&
    formValues?.transferLocation === "test"
  ) {
    return Promise.resolve();
  }
  return Promise.reject(new Error("This is a required field"));
};

export const validateZipFiles = (fileList: UploadFile[]) => {
  return (_: any, value: any) => {
    const fileNames = fileList.map((file) => file.name);
    const hasDuplicates = new Set(fileNames).size !== fileNames.length;

    if (hasDuplicates) {
      return Promise.reject(
        new Error(
          "Multiple files with the same name are not accepted. Please re-try using a different file name.",
        ),
      );
    }

    if (fileList.some((file) => !file.name.endsWith(".zip"))) {
      return Promise.reject(new Error("Only .zip files are permitted."));
    }

    if(fileList.length > 1) {
      return Promise.reject(new Error("Multiple files are not accepted."));
    }

    return Promise.resolve();
  };
};

export const FileInputError = (fileList: UploadFile[], form: FormInstance) => {
  const fieldError = form.getFieldError("fileInput");

  if (fieldError.length > 0) {
    return <span style={{ color: "red" }}>{fieldError[0]}</span>;
  }

  if (fileList.some((file) => !file.name.endsWith(".zip"))) {
    return <span style={{ color: "red" }}>Only .zip files are permitted.</span>;
  }

  if (new Set(fileList.map((file) => file.name)).size !== fileList.length) {
    return (
      <span style={{ color: "red" }}>
        Multiple files with the same name are not accepted. Please re-try using
        a different file name.
      </span>
    );
  }

  if(fileList.length > 1) {
        return <span style={{ color: "red" }}>Multiple files are not accepted.</span>;
    }
  return null;
};
